import EmployeeDashboardWrapper from "components/layouts/EmployeeDashboardWrapper"
import DefBreadcrumb from "components/ui/breadcrumb/DefBreadcrumb"
import { getCMSSegments } from "utils/helper"
import ChangePasswordForm from "../../../components/cms/ChangePasswordForm"
import Typography from "components/ui/typography"

const ChangePassword = () => {
  const segments = getCMSSegments()

  return (
    <EmployeeDashboardWrapper>
      <DefBreadcrumb
        segments={segments}
        prefix="cms"
      />
      <Typography
        variant="subheading4"
        as="h1"
        className="text-primary"
      >
        Ubah Password
      </Typography>

      <ChangePasswordForm />
    </EmployeeDashboardWrapper>
  )
}

export default ChangePassword
